module.exports = __webpack_public_path__ + "fonts/627fbb5a-3bae-4cd9-b617-2f923e29d55e.24932ad.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/627fbb5a-3bae-4cd9-b617-2f923e29d55e.woff2
// module id = 300
// module chunks = 245 246